<template>

    <div class="container-center">

        <el-form class="invite-form" label-width="140px" ref="form" :model="form" :rules="rules">

            <el-row>

                <el-col :span="10">
                    <el-form-item label="招标公告名称：" prop="name">
                        <el-input size="medium" v-model="form.name" clearable></el-input>
                    </el-form-item>
                </el-col>

                <!--<el-col :span="7">-->
                    <!--<el-form-item label="产品及服务：" prop="region">-->
                        <!--<el-input size="medium" v-model="form.productTypeName" clearable></el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->

                <el-col :span="6">
                    <el-form-item label="招标类型：" prop="type">
                        <el-select placeholder="请选择招标类型" size="medium" v-model="form.inviteProjectTypeEnum">
                            <el-option label="全部" :value=null></el-option>
                            <el-option label="采购" value="PROJECT_INVITED"></el-option>
                            <el-option label="战略" value="STRATEGY_INVITED"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row>

                <el-col :span="10">

                    <el-form-item label="报名截止时间：">

                        <el-col :span="11">
                            <el-date-picker type="date" v-model="form.signBeginTime" placeholder="选择日期" size="medium" style="width: 100%;" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2"><center>-</center></el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" v-model="form.signEndTime" placeholder="选择日期" size="medium" style="width: 100%;" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-col>

                    </el-form-item>

                </el-col>

                <el-col :span="3" :offset="1">
                    <el-button type="warning" class="btn-theme" size="medium" @click="getInviteList" icon="el-icon-search">搜索</el-button>
                </el-col>

            </el-row>

        </el-form>


        <div class="invite-list-box">

            <div class="no-data-tip" v-if="inviteList.length == 0"></div>

            <div v-else class="invite-list" v-for="list in inviteList">
                <div class="invite-list-calen">
                    <span class="big">{{(list.fdistributedate||'0000-00-00 00:00:00').substring(8,10) }}</span>
                    <span>{{ (list.fdistributedate||'0000-00-00 00:00:00').substring(5,7) }}月</span>
                    <span>{{ (list.fdistributedate||'0000-00-00 00:00:00').substring(0,4) }}</span>
                </div>
                <div class="invite-list-info">
                    <p v-bind:class="[list.finvitemethod.charAt(0) === '3' ? 'strategy' : '', 'title']" @click="showInfoDetail(list)" ><a style="cursor: pointer;">{{list.fname}}</a></p>
                    <!--<p><span class="icon-type">产品及服务：</span><span>{{ list.productTypeName }}</span></p>-->
                    <!--<p><span class="icon-proj">所属项目：</span><span>{{ list.fprojectname }}</span><span class="icon-time">报名截止时间：</span><span>{{ list.finvregisteddeadline }}</span></p>-->
                    <p><span class="icon-time">报名截止时间：</span><span>{{ list.finvregisteddeadline }}</span></p>
                    <p v-if="list.finvitemethod.charAt(0) != '3'"><span class="icon-proj">所属项目：</span><span>{{ list.fprojectname }}</span></p>
                </div>
                <div class="invite-list-btn" @click="showInfoDetail(list)">
                    <!--<router-link :to="{name:'InviteInfo',params:{ fid:list.fid }}" >-->
                        <el-button type="warning" class="btn-theme-plain" plain size="medium">
                            {{
                                list.isSign == '0'
                                ? (new Date().getTime() >= new Date(list.finvregisteddeadline.replace(/\-/g,'/')).getTime() ? '已截止' : '马上报名')
                                : '已报名'
                            }}
                        </el-button>
                    <!--</router-link>-->
                </div>
            </div>

        </div><!-- .invite-list-box -->

        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                :current-page="pager.pageNum"
                :total="pager.total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
                >
            </el-pagination>
        </div>
        <!--
            @size-change="handleSizeChange"
            :current-page.sync="currentPage1"
        -->

    </div><!-- container-center -->

</template>

<script>
import filter from '@/filter'
import banner from '@/assets/imgs/banner_invite.png'
import util from '@/util'

export default {
    name: 'invite-list',
    data () {
        return {
            loading: false,
            rules: {

            },
            inviteList: [],

            form: {
                name: "",
                productTypeName: "",
                inviteProjectTypeEnum: null,
                signBeginTime: "",
                signEndTime: "",
                signStatus: "",
                supplierId: this.$root.stockId || ''
            },
            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            }

        }
    },
    methods: {
        getInviteList () {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({ background:'rgba(255,255,255,0.5)'});
                    this.$http.post('rest/api/invite/project/list',
                        Object.assign(
                            {
                                supplierId: this.$root.stockId,
                                pageNum: this.pager.pageNum,
                                pageSize: this.pager.pageSize
                            },
                            this.form,
                            {
                                signBeginTime: this.form.signBeginTime ? filter.date(this.form.signBeginTime) +' 00:00:00' : '',
                                signEndTime: this.form.signEndTime ? filter.date(this.form.signEndTime) +' 23:59:59' : ''
                            }
                        )
                    ).then((res)=>{
                        loading.close();
                        if(res.data.result) {
                            this.inviteList = res.data.value.list;
                            this.pager.total = res.data.value.count;
                            this.pager.pageNum = res.data.value.pageNo;
                        } else {
                            this.$message({message: 'Error: 公告列表', type: 'error'})
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        checkShowDetail(cb){
            return this.$http.post('/rest/api/supplierHomepage/getStockStep', this.$root.stockId).then(res => {
                const data = res.data;
                if (data.result) {
                    if(data.value!=3){
                    	this.$message({message: 'Error: 审核未通过，不能查看详情', type: 'error'})

                    }else{
                    	!!cb&&cb()
                    }
                } else {
                    this.$message({message: 'Error: 公告列表', type: 'error'})

                }
            })

        },
        showInfoDetail(list){
        	if(!this.$root.stockId){
                this.$confirm('您尚未登录，请先登录后再查看！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
        			this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`);
                }).catch(() => {

                })
                return
        	}
            this.$router.push(`/InviteInfo/${encodeURIComponent(list.fid)}`)

        },
        handleCurrentChange (page) {
            this.pager.pageNum = page;
            this.getInviteList();
        }

    },
    created(){
        this.$root.navs = [{name:'招标公告',path:'/inviteList'}]
        this.$root.headImage.src = banner
        this.$root.activeIndex = 'invite'

        if(window.localStorage.getItem('isInMng')) {
            this.$root.activeIndex = 'home'
            this.$root.isPublic = false
        }

    },
    mounted () {
        if (this.$root.stockId) {
            util.hasIdCardNullFlag(this)
        }
        this.getInviteList();
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';


.invite-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}

.invite-list {width: 100%;height: 96px;padding: 24px 0;border-bottom: 1px solid #E4E5E4;}


/* 日历日期 */
.invite-list-calen {float: left;width: 92px;height: 92px;border: 1px solid #DDDEDD;}
.invite-list-calen > span {display: block;font-size: 14px;padding: 1px 10px;}
.invite-list-calen > span.big {color: var(--cMain);line-height: 32px;font-size: 32px;padding-top: 10px;padding-bottom: 4px;}


.invite-list-info {float: left;margin-left: 40px;}
.invite-list-info > p {margin: 0 0 16px 0;colors: #000;font-size: 14px;}
.invite-list-info > p.title {font-size: 18px;font-weight: bold;}
.invite-list-info > p.title a {color: #000;text-decoration: none;}
.invite-list-info > p.title a:hover {color: var(--cMain);}
.invite-list-info > p.title.strategy::after {content: '战略';display: inline-block;width: 40px;height: 22px;line-height: 22px;text-align: center;font-size: 12px;font-weight: normal;color: #fff;background: var(--cMint);border-radius: 2px;vertical-align: bottom;margin-left: 10px;}
.invite-list-info > p > span[class^=icon] {display: inline-block;color: #646464;padding-left: 22px;height: 15px;line-height: 16px;background: url("../../../assets/imgs/icon_invite_list_tri.png") no-repeat top left;}
.invite-list-info > p > span.icon-time {background-position: 0 -15px;}
.invite-list-info > p > span.icon-proj {background-position: 0 -30px;}
.invite-list-info > p > span + span[class^=icon] {margin-left: 30px;}


/* 报名按钮 */
.invite-list-btn {float: right;margin: 28px 30px 0 0;}

.btn-theme-plain {min-width: 98px;}


</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/InviteList.vue